@if (urls.length) {
  <div class="sg" [attr.data-count]="urls.length">
    @for (url of urls; track $index) {
      <button
        type="button"
        class="sg-tile"
        [attr.aria-label]="'Open photo ' + ($index + 1) + ' of ' + urls.length"
        (click)="openViewer($index)">
        <img [src]="url" alt="" loading="lazy" />
      </button>
    }
  </div>
}

@if (viewerIndex !== null) {
  <div class="sg-viewer" role="dialog" aria-modal="true" aria-label="Photo viewer" (click)="closeViewer()">
    <button type="button" class="sg-close" aria-label="Close" (click)="closeViewer()">&times;</button>
    @if (urls.length > 1) {
      <button type="button" class="sg-nav sg-prev" aria-label="Previous photo" (click)="step(-1, $event)">
        <i class="fa fa-chevron-left"></i>
      </button>
      <button type="button" class="sg-nav sg-next" aria-label="Next photo" (click)="step(1, $event)">
        <i class="fa fa-chevron-right"></i>
      </button>
    }
    <img class="sg-full" [src]="urls[viewerIndex]" alt="" (click)="$event.stopPropagation()" />
    @if (urls.length > 1) {
      <span class="sg-counter">{{ viewerIndex + 1 }} / {{ urls.length }}</span>
    }
  </div>
}
